export function SkeletonCard() {
  return (
    <div className="sk-card">
      <div className="skel sk-img" />
      <div className="sk-lines">
        <div className="skel sk-l1" /><div className="skel sk-l2" /><div className="skel sk-l3" />
      </div>
    </div>
  );
}
export function SkeletonGrid({ n = 6 }) {
  return <div className="feat-grid">{Array.from({ length: n }).map((_, i) => <SkeletonCard key={i} />)}</div>;
}
